export {default} from './CandidateDisposition';
